import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fes-scanpool',
  templateUrl: './scanpool.component.html',
  styleUrls: ['./scanpool.component.scss']
})
export class ScanpoolComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
